/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  class VideoWithUnmute extends HTMLElement {
    constructor() {
      super ();

      this.video = this.querySelector('video');
      this.controls = this.querySelectorAll('svg');

      if (this.video) {
        this.video.addEventListener('click', this.unmuteVideo.bind(this));
      }

      if (this.controls) {
        this.controls.forEach((control) => {
          control.addEventListener('click', this.unmuteVideo.bind(this));
        });
      }
    }

    unmuteVideo() {
      this.video.muted = !this.video.muted;
      if (this.dataset.volume === 'false') {
        this.dataset.volume = 'true'; 
      } else {
        this.dataset.volume = 'false'; 
      }
    }
  }

  customElements.define("video-with-unmute", VideoWithUnmute);

  class VideoPopUp extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('.btn');
      this.container = this.querySelector('.image-with-text__video-container');
      this.video = this.querySelector('.image-with-text__video');
      this.closeModalButton = this.querySelector('.image-with-text__video-container svg')

      if (this.button) {
        this.button.addEventListener('click', this.openModal.bind(this));
      }

      if (this.container) {
        this.container.addEventListener('click', this.closeModal.bind(this));
      }
    }

    openModal() {
      this.dataset.opened = "true";
      if (this.video) {
        this.video.currentTime = 0;
        this.video.play();
      }
    }

    closeModal(event) {
      if (event.target == this.container || event.target === this.closeModalButton)
        this.dataset.opened = "false";
    }
  }

  customElements.define("video-pop-up", VideoPopUp);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
